import React from 'react';
import PropTypes from 'prop-types';

import styles from './Radio.scss';

const Radio = ({name, label, value, onChange, labelClass, checked, checkmarkClass, id, readonly, customRef, defaultChecked}) => {
	return (
		<label className={`${styles.container} ${labelClass !== '' && labelClass}`}>{label}
			<input id={id} type="radio" name={name} value={value} onChange={onChange} checked={checked}
				   readOnly={readonly} ref={customRef} defaultChecked={defaultChecked}/>
			<span className={`${styles.checkmark} ${checkmarkClass}`}/>
		</label>
	);
};
Radio.defaultProps = {
	labelClass: '',
	checkmarkClass: ''
};

Radio.propTypes = {
	name: PropTypes.string,
	label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
	value: PropTypes.string.isRequired,
	checked: PropTypes.bool,
	onChange: PropTypes.func,
	labelClass: PropTypes.string,
	checkmarkClass: PropTypes.string,
	id: PropTypes.string,
	readonly: PropTypes.bool,
	defaultChecked: PropTypes.bool
};


export default Radio;